import { render } from "./EmployeeClassException.vue?vue&type=template&id=00770aa8&scoped=true"
import script from "./EmployeeClassException.vue?vue&type=script&lang=js"
export * from "./EmployeeClassException.vue?vue&type=script&lang=js"

import "./EmployeeClassException.vue?vue&type=style&index=0&id=00770aa8&scoped=true&lang=less"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00770aa8"]])

export default __exports__